import { Flavor } from "./flavor";
import { color2 } from "src/styles";
import { LogoClippers } from "src/components/LogoClippers";

export class ClippersFlavor extends Flavor {
  getMainColor() {
    return color2.DG_MAIN;
  }

  getDashLineColor() {
    return color2.DG_MAIN;
  }

  getCircleLogo() {
    return <LogoClippers />;
  }
}

const Singleton = new ClippersFlavor();
export default Singleton;
